import Component from 'vue-class-component';
import {SecurityQuestion, SecurityQuestions, UserApiService} from '@/services/generated/edge/user';
import {RegistrationVue} from '@/registration-vue';
import './clubcard-verify.scss';
import {loadSecurityQuestions} from '@/utils';

@Component({template: require('./clubcard-verify.html')})
export class ClubCardVerifyPage extends RegistrationVue {

  loading = false;

  mounted() {
    this.$store.state.clubcardNumber = '';
  }

  next() {
    this.loading = true;

    UserApiService.validateUser({
      email: this.$store.state.email,
      cardNumber: this.$store.state.clubcardNumber.replace(/ /g, ''),
      banner: ''
    }).then((validateResult) => {
      if (!validateResult.valid) {
        this.loading = false;
        this.alert('The last four digits you\'ve provided do not match - please try again.');
      } else {
        this.$store.state.firstName = validateResult.firstName;
        this.$store.state.lastName = validateResult.lastName;
        this.$store.state.presetPhoneNumber = validateResult.phoneNumber;
        this.$store.state.requireTitle = validateResult.requireTitle;

        loadSecurityQuestions(this.$store).then(() => {
          this.navigate('security-entry');
        }).catch(() => {
          this.loading = false;
        });
      }
    }).catch((error) => {
      this.loading = false;

      if (error.response.data.message == 'Validate failed') {
        this.alert('The last four digits you\'ve provided do not match - please try again.');
      } else {
        this.handleApiError(error);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/forms/clubcard-verify/clubcard-verify.ts